import { render } from "./TutarialCate.vue?vue&type=template&id=48111d1b&scoped=true"
import script from "./TutarialCate.vue?vue&type=script&lang=js"
export * from "./TutarialCate.vue?vue&type=script&lang=js"

import "./TutarialCate.vue?vue&type=style&index=0&id=48111d1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48111d1b"]])

export default __exports__